<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <Alert :text="apiErrorText" type="danger" dismissable="false" v-if="apiErrorText !=''" />
                <div style="overflow: hidden;">
                  <div class="col-md-12" style="justify-content: center; display: flex">
                    <img src="@/assets/Rectangle.svg" :alt="$t('error_message_for_loading_image')"
                      style="height: 15em; width:11em; margin-top: -2em">
                  </div>
                  <form action="">
                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name"
                          style="color: rgba(74, 73, 73, 0.7); margin-left: 2em;">{{ $t('organisation_profile_organisation_name_label') }}
                        </label>
                        <input type="text" class="form-control streetInput" v-model="organisationName" disabled />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-id"
                          style="color: rgba(74, 73, 73, 0.7); margin-left: 2em;">{{ $t('organisation_profile_organisation_number_label') }}
                        </label>
                        <input type="text" class="form-control streetInput" v-model="organizationNumber" disabled />

                      </div>
                    </div>

                  </form>
                  <div class="col-md-8 buttonDiv" >

                    <span class=" buttonSpan" >
                      <router-link :to="{name:'OrganizationProfilePage', params:{org: orgId }}">
                      <button type="button" class="btn  buttonStyle ml-1"
                        :class="this.$route.name==='OrganizationProfilePage' || this.$route.name==='OrganizationProfilePageEdit' ? 'btn-primary' : 'btn-light-secondary '" >
                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="fontStyle"
                          :class="this.$route.name==='OrganizationProfilePage'|| this.$route.name==='OrganizationProfilePageEdit' ? 'd-sm-block' : 'btn-light-secondary-font'"> {{ $t('organisation_profile_pacto_organization_profile_button') }}</span>
                      </button>
                      </router-link>
                    </span>
                    <span class=" buttonSpan">
                      <router-link :to="{name:'CLOUsersPage', params:{org: orgId }}">
                      <button type="button"  class="btn ml-1 buttonStyle"
                        :class="this.$route.name==='CLOUsersPage' ? 'btn-primary' : 'btn-light-secondary '">

                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="fontStyle"
                          :class="this.$route.name==='CLOUsersPage' ? 'd-sm-block' : 'btn-light-secondary-font'">{{ $t('organisation_profile_pacto_user_management_button') }}</span>
                      </button>
                    </router-link>
                    </span>
                    <span class=" buttonSpan">
                      <router-link :to="{name:'PactoSettingsPage', params:{org: orgId }}">
                      <button type="button"  class="btn  ml-1 buttonStyle"
                        :class="this.$route.name==='PactoSettingsPage' ? 'btn-primary' : 'btn-light-secondary '">
                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="fontStyle"
                          :class="this.$route.name==='PactoSettingsPage' ? 'd-sm-block' : 'btn-light-secondary-font'">{{ $t('organisation_profile_pacto_settings_button') }}</span>
                      </button>
                    </router-link>
                    </span>
                    <span class=" buttonSpan">
                      <router-link :to="{name:'PactoLegalPage', params:{org: orgId }}">
                      <button type="button"  class="btn ml-1 buttonStyle"
                        :class="this.$route.name==='PactoLegalPage' ? 'btn-primary' : 'btn-light-secondary '">
                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="fontStyle"
                          :class="this.$route.name==='PactoLegalPage'  ? 'd-sm-block' : 'btn-light-secondary-font'">{{ $t('organisation_profile_pacto_legal_button') }}</span>
                      </button>
                    </router-link>
                    </span>
                  </div>
                  <div>

                    <!-- <OrganizationProfilePage :orgId="orgId" v-if="organizationProfile" />


                    <CLOUsersPage :orgId="orgId" v-if="userManagement" />
                    <PactoLegalPage :orgId="orgId" v-if="pactoLegal" />
                    <PactoSettingsPage :orgId="orgId" v-if="organizationSettings" /> -->
                    <router-view/>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationProfilePage from "@/views/Organization Profile/OrganizationProfilePage";
import CLOUsersPage from "@/views/CLO Users/CLOUsersPage";
import PactoLegalPage from "@/views/PactoLegal/PactoLegalPage";
import PactoSettingsPage from "@/views/PactoSettings/PactoSettingsPage"
import Alert from "@/components/Alerts";
export default {
  name: "OrganizationCLOCommonPage",
  data() {
    return {
      organisationName: "",
      organizationNumber: "",
      organizationProfile: false,
      userManagement: false,
      organizationSettings: false,
      pactoLegal: false,
      orgData: {},
      apiErrorText: '',
      orgId: this.$route.params.org,
      backButton: false,
      orgRoot: false,
      orgDataLoaded:false
    }
  },

  components: {
    OrganizationProfilePage,
    Alert,
    CLOUsersPage,
    PactoLegalPage,
    PactoSettingsPage
  },
  methods: {

    getOrg() {
      let self = this;
      this.$apiCall.get(`v1/clo-organization/${self.orgId}`).then((response) => {
        self.orgData = response.data;
        self.orgDataLoaded = true;
        self.organisationName = self.orgData.officialName;
        self.organizationNumber = self.orgData.organizationId;
      }).catch((error) => {
        self.apiErrorText =
          `<strong>Ops!</strong> ${error.response.data.message}`;
      });
    },
  },
  mounted() {
    this.getOrg()
  }
}
</script>

<style scoped>
.buttonStyle {
  width: 13em;
  height: 3em;
  transform: translate(-30px, 10px);
  border-radius: 6px
}

.buttonSpan {
  margin-left: 2em;
  margin-right: 2em;
}

.buttonDiv {
  display: flex;
  height: 5em;
  margin-top: 2em;
}

.btn-light-secondary {
  background-color: #a9a6a6;
  color: #a9a6a6;
}

.btn-light-secondary-font {
  font-size: 14px;
  color: black !important;
  font-weight: 400;
}

.streetInput {
  height: 75%;
  width: 94%;
  margin-left: 2em;
}

.fontStyle {
  font-size: 16px;
}

@media (max-width: 1366px) {
  .buttonDiv {
    display: flex;
    height: 5em;
    margin-top: 2em;
    margin-left: 0em
  }
  .buttonSpan {
  margin-left: 2em ;
  margin-right: -2em !important;
}
  .buttonStyle {
    width: 11em;
    height: 3em;
    transform: translate(-30px, 10px);
    border-radius: 6px;
  }

  .buttonSpan {
    margin-left: 2em;
    margin-right: 3em;
  }

  .streetInput {
    height: 75%;
    width: 88%;
    margin-left: 2em;
  }

  .fontStyle {
    font-size: 13px;
  }

}
</style>
